// extracted by mini-css-extract-plugin
export default {"mCard":"UE-z","image":"VE-z","imageNoBackground":"WE-z","imageHasCategory":"XE-z","fullWidth":"YE-z"};